export const selectCurrentUser = (state) => state.auth.user;
export const selectIsAuthComplete = (state) => state.auth.isComplete;
export const selectIsAuthLoading = (state) => state.auth.loading;
